<template>
  <div class="card">
    <div class="p-6">
      <div class="flex items-center gap-2 mb-6">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 text-psychology-primary">
          <path d="M3 3v18h18"></path>
          <path d="M18.7 8a9 9 0 0 0-1.4-2.1"></path>
          <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path>
          <path d="M21 3v5h-5"></path>
          <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path>
          <path d="M8 16H3v5"></path>
        </svg>
        <h3 class="text-lg font-semibold text-gray-900">四维度雷达图</h3>
      </div>

      <div class="w-full">
        <Radar :data="chartData" :options="chartOptions" />
      </div>

      <div class="mt-4 text-sm text-gray-600">
        <p>雷达图显示了你在四个维度上的相对得分情况。越靠近边缘表示该维度得分越高。</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Radar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
} from 'chart.js'

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend)

export default {
  name: 'DimensionRadarChart',
  components: { Radar },
  props: {
    dimensionResults: {
      type: Array,
      required: true
    }
  },
  computed: {
    chartData() {
      const labels = this.dimensionResults.map(d => d.name)
      // 将Z分数转换为0-80的百分比显示（-3~+3 线性映射到 0~80）
      const toPercent = z => Math.round(Math.max(0, Math.min(80, 50 + z * 10)))
      const data = this.dimensionResults.map(d => toPercent(d.zScore))

      return {
        labels,
        datasets: [
          {
            label: '你的得分',
            data,
            backgroundColor: 'rgba(139, 92, 246, 0.2)', // #8b5cf6 20%
            borderColor: '#8b5cf6',
            borderWidth: 2,
            pointBackgroundColor: '#8b5cf6',
            pointBorderColor: '#ffffff',
            pointHoverBackgroundColor: '#ffffff',
            pointHoverBorderColor: '#8b5cf6'
          }
        ]
      }
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          r: {
            beginAtZero: true,
            suggestedMin: 0,
            suggestedMax: 80,
            ticks: {
              showLabelBackdrop: false,
              color: '#6b7280', // gray-500
              backdropColor: 'transparent',
              callback: (value) => `${value}%`
            },
            grid: {
              color: 'rgba(107, 114, 128, 0.2)'
            },
            angleLines: {
              color: 'rgba(107, 114, 128, 0.2)'
            },
            pointLabels: {
              color: '#374151', // gray-700
              font: {
                size: 12
              }
            }
          }
        },
        plugins: {
          legend: {
            display: true,
            labels: {
              color: '#374151'
            }
          },
          tooltip: {
            callbacks: {
              label: (context) => ` ${context.formattedValue}%`
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.card {
  /* Tailwind 的 @apply 在部分工具下会警告，保持简单原生样式以避免警告 */
  background-color: #ffffff;
  border-radius: 0.5rem;
  border: 1px solid rgba(229, 231, 235, 1);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

/* 让图表区域有合理高度 */
.w-full {
  min-height: 20rem; /* h-80 */
}
</style>
